export const appStringMap = {
  PE: "PE",
  CE: "CE",
  OPT: "OPT",
  FUT: "FUT",
  delivery: "delivery",
  carryForward: "carryForward",
  OrderConstants: {
    nse_eq: "NSE_EQ",
  },
  keys: {
    orderMarginSessionKey: "orderMarginSessionKey",
  },
  charges: {
    exchangeTurnover: "Exchange Turnover",
    brokerageBuy: "Brokerage",
    exchangeTransCharges: "Exchange Transaction Charges",
    sebiCharges: "SEBI Charges",
    securitiesTransactionCharges: "Securities Transaction Tax (STT)",
    gstChargesText: "GST",
    dpCharges: "DP Charges (inclusive of taxes)",
    clearingCharges: "Clearing Charges",
    stampDuty: "Stamp Duty",
    totalTaxChargesOnBuy: "Total tax & Charges",
  },
  routes:{
    setPassword:"/setPassword",
    resetPassword:"/FlowCreateNewPassword",
    mpInSet:"/MPinSet",
    mPin: "/MPin",
  },
  buttonVarientText:{
    continue: "Continue",
    setMpin: "Set MPIN",
  },
  validation:{
    mpin:{
      erroe:{
        mpinMustBeExactly4Digits:"MPIN must be exactly 4 digits",
        
        mpinShouldContainOnlyNumber:"Should contain only number",
        mpinShouldNotHaveSequentialDigits:"Don't use sequences like 1234 or 4321.",
        mpinShouldNotHaveAllSameDigits:"All 4 digit shouldn’t be same",
      }
    }
  }
};
